import React from 'react';
import _ from 'lodash';
import { Row, Col } from 'reactstrap';
import PropTypes from 'prop-types';
import Body from '../Components/layout/Body';
import ReviewRow from '../Components/layout/ReviewRow';
import { SUBTABS, CHOOSE_STEPS, SETUP_STEPS } from './ConstPaths';
import './Views.scss';
import { extractBodySiteButtons } from './ConstBodySiteBtns';
import { SELECTION_METHOD_BUTTONS, LOWTECH_SELECTION_METHOD_BUTTONS } from './ConstSelectionMethodBtns';
import { CONTROL_ACCESSORIES } from './ConstAccessMethodsMock';
import { LABELS_FOR_SETUP } from './ConstForTestDriveSection';
import TestDriveDevSidebar from './TestDriveDevSidebar';

const TD_SETUP_REVIEW_HELP = `
  <div>
    <p>
    If you’ve gone through all the setup steps, you’ve entered quite a bit of info in this section.  
    Take a minute to double-check what you’ve entered.  
    None of the info is required, but it provides a handy record to let you know exactly what you tried during this Test-drive. 
    </p>
    <p>
    To make a change, use the Update button to return to that specific page.
    </br>  
    <strong>Pro tip:</strong> After you’ve made your change, use Back or the back arrow to return here. 
    That way you don’t have to go through all the other setup pages again. 
    </p>
  </div>
`;

const propTypes = {
  firstName: PropTypes.string,
  activeAccessMethodName: PropTypes.string,
  activeAccessMethodCategory: PropTypes.string,
  activeSetupSelectionMethod: PropTypes.string,
  activeSetupBodySite: PropTypes.arrayOf(PropTypes.string),
  activeSetupBodySiteComments: PropTypes.string,
  activeSetupAccessories: PropTypes.arrayOf(PropTypes.string),
  activeSetupPositioningNotes: PropTypes.string,
  activeSetupOtherNotes: PropTypes.string,
  activeSetupName: PropTypes.string,
  onContinue: PropTypes.func.isRequired
};

const defaultProps = {
  firstName: 'the client',
  activeAccessMethodName: '',
  activeAccessMethodCategory: '',
  activeSetupSelectionMethod: '',
  activeSetupBodySite: [],
  activeSetupBodySiteComments: '',
  activeSetupAccessories: [],
  activeSetupPositioningNotes: '',
  activeSetupOtherNotes: '',
  activeSetupName: '',
};

//content sub-component with unique content for this page
function SetupReviewContent(props) {
  const activeAccessMethodName = props.activeAccessMethodName;
  const activeSetupSelectionMethod = props.activeSetupSelectionMethod;
  const activeSetupBodySite = props.activeSetupBodySite;
  const activeSetupBodySiteComments = props.activeSetupBodySiteComments;
  const activeSetupAccessories = props.activeSetupAccessories;
  const activeSetupPositioningNotes = props.activeSetupPositioningNotes;
  const activeSetupOtherNotes = props.activeSetupOtherNotes;
  const activeSetupName = props.activeSetupName;
  
  const bodySiteBtns = extractBodySiteButtons();
  const selectionMethodBtnsWithDups = SELECTION_METHOD_BUTTONS.concat(LOWTECH_SELECTION_METHOD_BUTTONS);
  const selectionMethodBtns = _.uniqWith(selectionMethodBtnsWithDups, _.isEqual);
  
  console.log("rendering SetupReviewContent");

  return(
  <>
    <Row>
      <Col>
      <div className="row aa-review-row border-top">
        <div className="col-md-1">
          <span className={`fa fa-gears fa-2x aa-testdrive-color`}></span>
        </div>
        <div className="col">
          {/* <h5>Access Method</h5> */}
          <div className="col">
            <ReviewRow 
              border="none"
              padded="none"
              heading={LABELS_FOR_SETUP.ACCESS_METHOD}
              nextRoute={SUBTABS.CHOOSE+"/"+CHOOSE_STEPS.ACCESS_METHOD}
              values={activeAccessMethodName}
              lookup={null}
            />
            <ReviewRow 
              border="none"
              padded="none"
              heading={LABELS_FOR_SETUP.SELECTION_METHOD}
              nextRoute={SUBTABS.SETUP+"/"+SETUP_STEPS.SELECTION_METHOD}
              values={activeSetupSelectionMethod}
              lookup={selectionMethodBtns}
            />
            <ReviewRow 
              border="none"
              padded="none"
              heading={LABELS_FOR_SETUP.BODY_SITES}
              nextRoute={SUBTABS.SETUP+"/"+SETUP_STEPS.BODY_SITES}
              values={activeSetupBodySite}
              lookup={bodySiteBtns}
            />
            <ReviewRow 
              border="none"
              padded="none"
              heading={LABELS_FOR_SETUP.BODY_SITE_COMMENTS}
              nextRoute={SUBTABS.SETUP+"/"+SETUP_STEPS.BODY_SITES}
              values={activeSetupBodySiteComments}
              lookup={null}
            />
            <ReviewRow 
              border="none"
              padded="none"
              heading={LABELS_FOR_SETUP.ACCESSORIES}
              nextRoute={SUBTABS.SETUP+"/"+SETUP_STEPS.ACCESSORIES}
              values={activeSetupAccessories}
              lookup={CONTROL_ACCESSORIES}
            />
            <ReviewRow 
              border="none"
              padded="none"
              heading={LABELS_FOR_SETUP.POSITIONING} 
              nextRoute={SUBTABS.SETUP+"/"+SETUP_STEPS.INFO}
              values={activeSetupPositioningNotes}
              lookup={null}
            />
            <ReviewRow 
              border="none"
              padded="none"
              heading={LABELS_FOR_SETUP.OTHER}
              nextRoute={SUBTABS.SETUP+"/"+SETUP_STEPS.INFO}
              values={activeSetupOtherNotes}
              lookup={null}
            />
            <ReviewRow 
              border="none"
              padded="none"
              heading={LABELS_FOR_SETUP.NAME}
              nextRoute={SUBTABS.SETUP+"/"+SETUP_STEPS.NAME}
              values={activeSetupName}
              lookup={null}
            />
          </div>
        </div>
      </div>
      </Col> 
      <Col lg={2}></Col>
    </Row>
    <Row>
      <Col>
      You can Update a section if you want to make changes.  When you're done with all relevant sections, select Continue.
      </Col>
    </Row>
  </>
  );
}

//main component for this page
//basic pattern is to set up the pageData, define the unique content for the page (above),
//then render the page using <Body> component.
function TestDriveSetupReview(props) {
  const activeAccessMethodName = props.activeAccessMethodName;
  const activeSetupSelectionMethod = props.activeSetupSelectionMethod;
  const activeSetupBodySite = props.activeSetupBodySite;
  const activeSetupBodySiteComments = props.activeSetupBodySiteComments;
  const activeSetupAccessories = props.activeSetupAccessories;
  const activeSetupPositioningNotes = props.activeSetupPositioningNotes;
  const activeSetupOtherNotes = props.activeSetupOtherNotes;
  const activeSetupName = props.activeSetupName;
  const onContinue = props.onContinue;

  const dev = props.dev || {};

  console.log("rendering TestDriveSetupReview, with props: " + JSON.stringify(activeSetupSelectionMethod));
 
  const pageData = {
    image: "", //not yet used
    faIcon:  "",
    pageSymbolClassName: "aa-section-symbol test-drive",
    title: `Review what you've set up for the Test-drive`,
    subTitle: "Here's what we've got so far:",
    learnMore: {linkText: "Learn more about Test-drive setup",
                title: "Test-drive setup",
                content: TD_SETUP_REVIEW_HELP
                },
    nextRoute: "", //not used since we have an onContinue callback
    sidebar: false
  }

  return(
    <>
    <Body page={pageData} 
      contentComponent={
        <SetupReviewContent 
        activeAccessMethodName={activeAccessMethodName}
        activeSetupSelectionMethod={activeSetupSelectionMethod}
        activeSetupBodySite={activeSetupBodySite}
        activeSetupBodySiteComments={activeSetupBodySiteComments}
        activeSetupAccessories={activeSetupAccessories}
        activeSetupPositioningNotes={activeSetupPositioningNotes}
        activeSetupOtherNotes={activeSetupOtherNotes}
        activeSetupName={activeSetupName}
      />
      }
      sidebarComponent={
        dev.showDevSidebar 
        &&
        <TestDriveDevSidebar 
          activeTestDriveId={dev.tdId}
          activeTestDrive={dev.td}
          activeTestDriveActivityId={dev.actId}
          activeTestDriveActivities={dev.acts}
          completedTestDrives={dev.ctds}
        />  
      }
      onContinue={onContinue} 
    />
    </>
  );
}

TestDriveSetupReview.propTypes = propTypes;
TestDriveSetupReview.defaultProps = defaultProps;

export default TestDriveSetupReview;